(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-featured-media"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var videos = document.querySelectorAll('.collection-featured-media__video');
    videos.forEach(function (video) {
      video.muted = true;
      video.playsInline = true;
      var attempt = function () {
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            document.addEventListener(
              'click',
              function () { video.play().catch(function () {}); },
              { once: true, capture: true }
            );
          });
        }
      };
      if (video.readyState >= 2) {
        attempt();
      } else {
        video.addEventListener('loadeddata', attempt, { once: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var modal = document.getElementById('newsletter-thanks');
    if (!modal) return;

    function close() {
      modal.style.opacity = '0';
      setTimeout(function () { modal.remove(); }, 200);

      if (window.history && window.history.replaceState) {
        var url = window.location.pathname + window.location.search;
        window.history.replaceState({}, document.title, url + window.location.hash.replace(/#contact_form.*/, ''));
      }
    }

    modal.querySelectorAll('[data-newsletter-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    modal.style.transition = 'opacity 0.2s ease';
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.getElementById('site-header');
    var drawer = document.getElementById('nav-drawer');
    var drawerClose = drawer.querySelector('.header__drawer-close');
    var menuPanels = drawer.querySelectorAll('[data-menu-handle]');
    var menuButtons = document.querySelectorAll('[data-open-menu]');
    var cartDrawer = document.getElementById('cart-drawer');
    var cartButtons = document.querySelectorAll('[data-open-cart]');
    var searchDrawer = document.getElementById('search-drawer');
    var searchButtons = document.querySelectorAll('[data-open-search]');
    var searchForm = searchDrawer.querySelector('[data-search-form]');
    var searchInput = searchDrawer.querySelector('[data-search-input]');
    var searchResults = searchDrawer.querySelector('[data-search-results]');

    /* Drawer open/close */
    function openNavDrawer(handle) {
      menuPanels.forEach(function(panel) {
        panel.hidden = panel.getAttribute('data-menu-handle') !== handle;
      });
      drawer.showModal();
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          drawer.classList.add('header__drawer--open');
        });
      });
    }

    menuButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        openNavDrawer(btn.getAttribute('data-open-menu'));
      });
    });

    var navButtons = document.querySelectorAll('[data-open-nav]');
    navButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        openNavDrawer('__primary__');
      });
    });

    function closeDrawer() {
      drawer.classList.remove('header__drawer--open');
      setTimeout(function() {
        drawer.close();
      }, 300);
    }

    drawerClose.addEventListener('click', closeDrawer);

    drawer.addEventListener('click', function(e) {
      if (e.target === drawer) {
        closeDrawer();
      }
    });

    /* Cart drawer open/close */
    function openCartDrawer() {
      cartDrawer.showModal();
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          cartDrawer.classList.add('header__drawer--open');
        });
      });
    }

    function closeCartDrawer() {
      cartDrawer.classList.remove('header__drawer--open');
      setTimeout(function() {
        cartDrawer.close();
      }, 300);
    }

    cartButtons.forEach(function(btn) {
      btn.addEventListener('click', openCartDrawer);
    });

    cartDrawer.addEventListener('click', function(e) {
      if (e.target === cartDrawer) {
        closeCartDrawer();
      }
      if (e.target.closest('[data-close-cart]')) {
        closeCartDrawer();
      }
    });

    /* Search drawer open/close */
    function openSearchDrawer() {
      searchDrawer.showModal();
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          searchDrawer.classList.add('search-drawer--open');
          searchInput.focus();
        });
      });
    }

    function closeSearchDrawer() {
      searchDrawer.classList.remove('search-drawer--open');
      setTimeout(function() {
        searchDrawer.close();
      }, 300);
    }

    searchButtons.forEach(function(btn) {
      btn.addEventListener('click', openSearchDrawer);
    });

    searchDrawer.addEventListener('click', function(e) {
      if (e.target === searchDrawer) {
        closeSearchDrawer();
      }
      if (e.target.closest('[data-close-search]')) {
        closeSearchDrawer();
      }
    });

    /* Predictive search */
    var searchTimer = null;
    var searchAbort = null;
    var lastQuery = '';

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var symbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
      return amount + (symbol ? ' ' + symbol : '');
    }

    var searchUrl = searchDrawer.dataset.searchUrl || '/search';
    var noResultsTemplate = searchDrawer.dataset.noResults || 'No results for {{ terms }}';
    var viewAllLabel = searchDrawer.dataset.viewAll || 'Search';

    function renderSearchResults(query, products) {
      if (!products.length) {
        var msg = noResultsTemplate.replace('__TERMS__', escapeHtml(query));
        searchResults.innerHTML = '<p class="search-drawer__status">' + msg + '</p>';
        return;
      }

      var items = products.map(function(p) {
        var imgSrc = '';
        if (p.featured_image && p.featured_image.url) {
          var sep = p.featured_image.url.indexOf('?') === -1 ? '?' : '&';
          imgSrc = p.featured_image.url + sep + 'width=400';
        }
        var img = imgSrc
          ? '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="400" height="533">'
          : '';
        var price = (typeof p.price === 'number')
          ? formatMoney(p.price)
          : (p.price || '');
        return (
          '<li class="search-drawer__item">' +
            '<a href="' + escapeHtml(p.url) + '">' +
              '<div class="search-drawer__item-image">' + img + '</div>' +
              '<p class="search-drawer__item-title">' + escapeHtml(p.title) + '</p>' +
              '<p class="search-drawer__item-price">' + price + '</p>' +
            '</a>' +
          '</li>'
        );
      }).join('');

      var viewAllUrl = searchUrl + '?q=' + encodeURIComponent(query) + '&type=product';
      searchResults.innerHTML =
        '<ul class="search-drawer__grid">' + items + '</ul>' +
        '<a class="search-drawer__view-all" href="' + escapeHtml(viewAllUrl) + '">' +
          escapeHtml(viewAllLabel) +
        '</a>';
    }

    function runSearch(query) {
      if (searchAbort) searchAbort.abort();
      searchAbort = new AbortController();

      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';

      fetch(url, { signal: searchAbort.signal })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (query !== lastQuery) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderSearchResults(query, products);
        })
        .catch(function(err) {
          if (err && err.name === 'AbortError') return;
          searchResults.innerHTML = '';
        });
    }

    searchInput.addEventListener('input', function() {
      var query = searchInput.value.trim();
      lastQuery = query;
      clearTimeout(searchTimer);
      if (!query) {
        if (searchAbort) searchAbort.abort();
        searchResults.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function() { runSearch(query); }, 200);
    });

    searchForm.addEventListener('submit', function(e) {
      if (!searchInput.value.trim()) {
        e.preventDefault();
      }
    });

    /* Reset --open classes when the dialog closes (e.g. via Escape key) */
    cartDrawer.addEventListener('close', function() {
      cartDrawer.classList.remove('header__drawer--open');
    });
    drawer.addEventListener('close', function() {
      drawer.classList.remove('header__drawer--open');
    });
    searchDrawer.addEventListener('close', function() {
      searchDrawer.classList.remove('search-drawer--open');
    });

    /* Apply rendered header HTML to the cart drawer */
    function applyHeaderHtml(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newContent = doc.querySelector('[data-cart-drawer-content]');
      var current = cartDrawer.querySelector('[data-cart-drawer-content]');
      if (newContent && current) {
        current.innerHTML = newContent.innerHTML;
      }
    }

    /* Fetch fresh header section HTML (used as a fallback) */
    function refreshCartDrawer() {
      var url = new URL(window.location.href);
      url.searchParams.set('sections', header.dataset.sectionId || 'header');
      return fetch(url.toString())
        .then(function(res) { return res.json(); })
        .then(function(data) {
          var key = Object.keys(data)[0];
          if (key) applyHeaderHtml(data[key]);
        })
        .catch(function() {});
    }

    /* Toggle transparent header based on which observed section is in view */
    var observedSections = document.querySelectorAll('.section--full-height, .collection-featured-media');

    /* Sync initial state so the IO callback doesn't cause a flash from dark to transparent */
    if (observedSections.length) {
      var firstObserved = observedSections[0];
      if (firstObserved.hasAttribute('data-transparent-header')) {
        var rect = firstObserved.getBoundingClientRect();
        var viewportMid = window.innerHeight * 0.5;
        if (rect.top < viewportMid && rect.bottom > viewportMid) {
          header.classList.add('header--transparent');
        }
      }
    }
    document.documentElement.classList.add('header-ready');

    if (observedSections.length) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            var isTransparent = entry.target.hasAttribute('data-transparent-header');
            header.classList.toggle('header--transparent', isTransparent);
          }
        });
      }, { threshold: [0, 0.5] });

      observedSections.forEach(function(section) {
        observer.observe(section);
      });
    }

    /* Cart line item: stepper + remove (delegated, works on drawer + cart page) */
    var cartChangeBusy = false;

    function changeCartLine(lineKey, quantity, surfaceEl) {
      if (cartChangeBusy) return;
      cartChangeBusy = true;

      var sectionsToFetch = [];
      if (header && header.dataset.sectionId) sectionsToFetch.push(header.dataset.sectionId);
      var cartSection = document.querySelector('[data-cart-section]');
      var cartSectionId = cartSection && cartSection.dataset.sectionId;
      if (cartSectionId) sectionsToFetch.push(cartSectionId);

      var body = {
        id: lineKey,
        quantity: quantity
      };
      if (sectionsToFetch.length) body.sections = sectionsToFetch.join(',');

      if (surfaceEl) surfaceEl.classList.add('cart-line--busy');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          var headerHtml = data.sections && header ? data.sections[header.dataset.sectionId] : null;
          if (cartSection && cartSectionId && data.sections && data.sections[cartSectionId]) {
            var doc = new DOMParser().parseFromString(data.sections[cartSectionId], 'text/html');
            var fresh = doc.querySelector('[data-cart-section]');
            if (fresh) cartSection.innerHTML = fresh.innerHTML;
          }
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { count: data.item_count, headerHtml: headerHtml, openDrawer: false }
          }));
        })
        .catch(function() {})
        .then(function() {
          cartChangeBusy = false;
        });
    }

    document.addEventListener('click', function(e) {
      var line = e.target.closest('[data-cart-line]');
      if (!line) return;
      var key = line.getAttribute('data-cart-line');
      if (!key) return;

      if (e.target.closest('[data-cart-increment]')) {
        var qtyEl = line.querySelector('[data-cart-quantity]');
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
        changeCartLine(key, current + 1, line);
      } else if (e.target.closest('[data-cart-decrement]')) {
        var qtyEl2 = line.querySelector('[data-cart-quantity]');
        var current2 = qtyEl2 ? parseInt(qtyEl2.textContent, 10) || 0 : 0;
        changeCartLine(key, Math.max(0, current2 - 1), line);
      } else if (e.target.closest('[data-cart-remove]')) {
        changeCartLine(key, 0, line);
      }
    });

    /* Re-sync cart on bfcache restore (Back/Forward navigation) */
    window.addEventListener('pageshow', function(event) {
      if (event.persisted) {
        fetch('/cart.js', { cache: 'no-store' })
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { count: cart.item_count, openDrawer: false }
            }));
          })
          .catch(function() {});
      }
    });

    /* Update cart count on AJAX add-to-cart */
    document.addEventListener('cart:updated', function(e) {
      var count = e.detail.count;
      var openDrawer = e.detail.openDrawer !== false;

      if (e.detail.headerHtml) {
        applyHeaderHtml(e.detail.headerHtml);
        if (openDrawer) openCartDrawer();
      } else {
        refreshCartDrawer().then(function() {
          if (openDrawer) openCartDrawer();
        });
      }

      /* Update text-based cart count (desktop) */
      var textCount = header.querySelector('.header__cart-count');
      if (count > 0) {
        if (textCount) {
          textCount.textContent = '(' + count + ')';
        }
      } else if (textCount) {
        textCount.textContent = '';
      }

      /* Update icon badge (mobile) */
      var cartLink = header.querySelector('.header__cart');
      if (!cartLink) return;

      var badge = cartLink.querySelector('.header__cart-badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'header__cart-badge';
          var iconWrap = cartLink.querySelector('.header__action-icon');
          if (iconWrap) iconWrap.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.product__media');
    sections.forEach(function(section) {
      var track = section.querySelector('[data-carousel-track]');
      if (!track) return;

      var slides = track.querySelectorAll('.product__carousel-slide');
      var prevBtn = section.querySelector('[data-carousel-prev]');
      var nextBtn = section.querySelector('[data-carousel-next]');
      var thumbnails = section.querySelectorAll('[data-thumbnail-index]');
      var currentIndex = 0;

      function goToSlide(index) {
        if (index < 0 || index >= slides.length) return;
        slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }

      function setActive(index) {
        currentIndex = index;
        thumbnails.forEach(function(thumb) {
          var i = parseInt(thumb.getAttribute('data-thumbnail-index'), 10);
          thumb.classList.toggle('product__thumbnail--active', i === index);
        });
        var activeThumb = thumbnails[index];
        if (activeThumb && activeThumb.parentElement) {
          var container = activeThumb.parentElement;
          var target = activeThumb.offsetLeft - (container.clientWidth - activeThumb.clientWidth) / 2;
          container.scrollTo({ left: target, behavior: 'smooth' });
        }
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var index = parseInt(entry.target.getAttribute('data-slide-index'), 10);
            setActive(index);
          }
        });
      }, {
        root: track,
        threshold: 0.5
      });

      slides.forEach(function(slide) { observer.observe(slide); });

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          goToSlide(currentIndex - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          goToSlide(currentIndex + 1);
        });
      }

      thumbnails.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var index = parseInt(thumb.getAttribute('data-thumbnail-index'), 10);
          goToSlide(index);
        });
      });

      track.setAttribute('tabindex', '0');
      track.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goToSlide(currentIndex - 1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          goToSlide(currentIndex + 1);
        }
      });
    });
  })();

  (function() {
    var lightbox = document.querySelector('[data-lightbox]');
    if (!lightbox) return;

    var lbTrack = lightbox.querySelector('[data-lightbox-track]');
    var lbSlides = lightbox.querySelectorAll('[data-lightbox-slide-index]');
    var lbImages = lightbox.querySelectorAll('.product__lightbox-image');
    var lbCounter = lightbox.querySelector('[data-lightbox-counter]');
    var lbClose = lightbox.querySelector('[data-lightbox-close]');
    var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
    var lbNext = lightbox.querySelector('[data-lightbox-next]');
    var lbThumbs = lightbox.querySelectorAll('[data-lightbox-thumb-index]');
    var triggers = document.querySelectorAll('.product__carousel-slide');
    var current = 0;
    var lastFocused = null;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function setCounter() {
      if (!lbCounter || !lbSlides.length) return;
      lbCounter.textContent = pad(current + 1) + '  —  ' + pad(lbSlides.length);
    }

    function setActiveThumb() {
      if (!lbThumbs.length) return;
      lbThumbs.forEach(function(thumb) {
        var i = parseInt(thumb.getAttribute('data-lightbox-thumb-index'), 10);
        thumb.classList.toggle('product__lightbox-thumbnail--active', i === current);
      });
      var active = lbThumbs[current];
      if (active && active.parentElement) {
        var container = active.parentElement;
        var target = active.offsetLeft - (container.clientWidth - active.clientWidth) / 2;
        container.scrollTo({ left: target, behavior: 'smooth' });
      }
    }

    function jumpTo(index, smooth) {
      if (index < 0 || index >= lbSlides.length) return;
      var slide = lbSlides[index];
      lbTrack.scrollTo({
        left: slide.offsetLeft,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }

    function open(index) {
      lastFocused = document.activeElement;
      current = index || 0;
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.setAttribute('data-lightbox-open', '');

      requestAnimationFrame(function() {
        jumpTo(current, false);
        requestAnimationFrame(function() {
          lightbox.setAttribute('data-open', 'true');
          setCounter();
          setActiveThumb();
        });
      });

      if (lbClose) lbClose.focus({ preventScroll: true });
    }

    function close() {
      lightbox.removeAttribute('data-open');
      lbImages.forEach(function(img) {
        img.removeAttribute('data-zoomed');
        img.style.transformOrigin = '';
      });

      var finish = function() {
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.removeAttribute('data-lightbox-open');
        lightbox.removeEventListener('transitionend', onEnd);
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus({ preventScroll: true });
        }
      };
      var onEnd = function(e) {
        if (e.target === lightbox && e.propertyName === 'opacity') finish();
      };
      lightbox.addEventListener('transitionend', onEnd);
      setTimeout(finish, 600);
    }

    function step(delta) {
      var next = current + delta;
      if (next < 0 || next >= lbSlides.length) return;
      jumpTo(next, true);
    }

    triggers.forEach(function(trigger, i) {
      trigger.addEventListener('click', function() { open(i); });
    });

    if (lbClose) lbClose.addEventListener('click', close);
    if (lbPrev) lbPrev.addEventListener('click', function() { step(-1); });
    if (lbNext) lbNext.addEventListener('click', function() { step(1); });

    lbThumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var i = parseInt(thumb.getAttribute('data-lightbox-thumb-index'), 10);
        jumpTo(i, true);
      });
    });

    lbSlides.forEach(function(slide) {
      var img = slide.querySelector('.product__lightbox-image');

      slide.addEventListener('click', function(e) {
        if (!img) { close(); return; }

        if (e.target === img) {
          if (img.getAttribute('data-zoomed') === 'true') {
            img.removeAttribute('data-zoomed');
            img.style.transformOrigin = '';
          } else {
            var rect = img.getBoundingClientRect();
            var x = ((e.clientX - rect.left) / rect.width) * 100;
            var y = ((e.clientY - rect.top) / rect.height) * 100;
            img.style.transformOrigin = x + '% ' + y + '%';
            img.setAttribute('data-zoomed', 'true');
          }
        } else {
          close();
        }
      });

      if (img) {
        img.addEventListener('pointermove', function(e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          if (img.getAttribute('data-zoomed') !== 'true') return;
          var rect = img.getBoundingClientRect();
          var x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
          var y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
          img.style.transformOrigin = x + '% ' + y + '%';
        });
      }
    });

    var lbObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var i = parseInt(entry.target.getAttribute('data-lightbox-slide-index'), 10);
          if (i !== current) {
            current = i;
            setCounter();
            setActiveThumb();
            lbImages.forEach(function(img) {
              img.removeAttribute('data-zoomed');
              img.style.transformOrigin = '';
            });
          }
        }
      });
    }, { root: lbTrack, threshold: 0.6 });
    lbSlides.forEach(function(slide) { lbObserver.observe(slide); });

    document.addEventListener('keydown', function(e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });

    function warmCache() {
      var conn = navigator.connection;
      if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;

      lbImages.forEach(function(img, i) {
        setTimeout(function() {
          var src = img.getAttribute('src');
          if (!src) return;
          var preloader = new Image();
          preloader.decoding = 'async';
          preloader.src = src;
        }, i * 120);
      });
    }

    function scheduleWarm() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(warmCache, { timeout: 3000 });
      } else {
        setTimeout(warmCache, 800);
      }
    }

    if (document.readyState === 'complete') {
      scheduleWarm();
    } else {
      window.addEventListener('load', scheduleWarm, { once: true });
    }
  })();

  (function() {
    var products = document.querySelectorAll('.product');
    products.forEach(function(productEl) {
      var dataEl = productEl.querySelector('[data-product-variants]');
      var idInput = productEl.querySelector('[data-variant-id-input]');
      var form = productEl.querySelector('form[action*="/cart/add"]');
      if (!dataEl || !idInput || !form) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!Array.isArray(variants) || !variants.length) return;

      var addBtn = productEl.querySelector('.product__add-to-cart');
      var addBtnText = addBtn && addBtn.querySelector('.product__add-to-cart-text');

      function readSelection() {
        var selected = [];
        productEl.querySelectorAll('.product__option').forEach(function(field) {
          var checked = field.querySelector('input[type="radio"]:checked');
          if (checked) selected.push(checked.value);
        });
        return selected;
      }

      function findVariant(values) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < values.length; j++) {
            if (v.options[j] !== values[j]) { match = false; break; }
          }
          if (match) return v;
        }
        return null;
      }

      function update() {
        var values = readSelection();
        var variant = findVariant(values);
        if (!variant) return;

        idInput.value = variant.id;

        if (addBtn && addBtnText) {
          if (variant.available) {
            addBtn.disabled = false;
            if (addBtn.dataset.availableText) {
              addBtnText.textContent = addBtn.dataset.availableText;
            }
          } else {
            addBtn.disabled = true;
            if (addBtn.dataset.soldOutText) {
              addBtnText.textContent = addBtn.dataset.soldOutText;
            }
          }
        }
      }

      productEl.querySelectorAll('.product__option input[type="radio"]').forEach(function(input) {
        input.addEventListener('change', update);
      });
    });
  })();

  (function() {
    var forms = document.querySelectorAll('.product form[action*="/cart/add"]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var button = form.querySelector('.product__add-to-cart');
        var textEl = button.querySelector('.product__add-to-cart-text');
        if (button.disabled) return;

        var originalText = textEl.textContent;
        button.disabled = true;

        var formData = new FormData(form);
        var headerEl = document.getElementById('site-header');
        var headerSectionId = headerEl && headerEl.dataset.sectionId;
        if (headerSectionId) {
          formData.append('sections', headerSectionId);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        })
          .then(function(res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function(data) {
            /* Fade out old text */
            button.classList.add('product__add-to-cart--transitioning');
            setTimeout(function() {
              textEl.textContent = document.querySelector('[data-added-text]').value;
              button.classList.remove('product__add-to-cart--transitioning');
            }, 300);

            /* Revert after 2s */
            setTimeout(function() {
              button.classList.add('product__add-to-cart--transitioning');
              setTimeout(function() {
                textEl.textContent = originalText;
                button.classList.remove('product__add-to-cart--transitioning');
                button.disabled = false;
              }, 300);
            }, 2000);

            var headerHtml = data.sections && headerSectionId ? data.sections[headerSectionId] : null;
            var count = null;
            if (headerHtml) {
              var match = headerHtml.match(/data-cart-count="(\d+)"/);
              if (match) count = parseInt(match[1], 10);
            }
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { count: count, headerHtml: headerHtml }
            }));
          })
          .catch(function() {
            button.classList.add('product__add-to-cart--transitioning');
            setTimeout(function() {
              textEl.textContent = document.querySelector('[data-error-text]').value;
              button.classList.remove('product__add-to-cart--transitioning');
            }, 300);

            setTimeout(function() {
              button.classList.add('product__add-to-cart--transitioning');
              setTimeout(function() {
                textEl.textContent = originalText;
                button.classList.remove('product__add-to-cart--transitioning');
                button.disabled = false;
              }, 300);
            }, 2000);
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["returns-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-returns-form-section]');
    if (!section) return;

    var form = section.querySelector('#returns-form');
    if (!form) return;

    var thankYouUrl = section.getAttribute('data-thank-you-url');
    if (!thankYouUrl) return;

    var submitBtn = form.querySelector('.returns-form__submit');

    var exchangeField = form.querySelector('[data-exchange-field]');
    var exchangeInput = form.querySelector('[data-exchange-input]');
    var typeRadios = form.querySelectorAll('input[name="contact[request_type]"]');

    function syncRequestType() {
      var selected = form.querySelector('input[name="contact[request_type]"]:checked');
      var isExchange = selected && selected.getAttribute('data-request-type') === 'exchange';

      if (exchangeField) {
        if (isExchange) {
          exchangeField.removeAttribute('hidden');
        } else {
          exchangeField.setAttribute('hidden', '');
        }
      }

      if (exchangeInput) {
        if (isExchange) {
          exchangeInput.setAttribute('required', '');
        } else {
          exchangeInput.removeAttribute('required');
          exchangeInput.value = '';
        }
      }
    }

    typeRadios.forEach(function(radio) {
      radio.addEventListener('change', syncRequestType);
    });
    syncRequestType();

    function resetSubmitButton() {
      if (!submitBtn) return;
      submitBtn.disabled = false;
      var submitText = submitBtn.getAttribute('data-submit-text');
      if (submitText) submitBtn.textContent = submitText;
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      if (submitBtn) {
        submitBtn.disabled = true;
        var sendingText = submitBtn.getAttribute('data-sending-text');
        if (sendingText) submitBtn.textContent = sendingText;
      }

      var formData = new FormData(form);

      fetch(form.action || window.location.href, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'text/html' },
        credentials: 'same-origin'
      })
        .then(function(response) {
          var finalUrl = response.url || '';
          var decoded;
          try { decoded = decodeURIComponent(finalUrl); } catch (err) { decoded = finalUrl; }

          if (decoded.indexOf('posted_successfully=true') !== -1) {
            window.location.href = thankYouUrl;
            return;
          }

          window.location.href = finalUrl || window.location.href;
        })
        .catch(function() {
          resetSubmitButton();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
